import React, { useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap, FiPhone } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import {
  FaWhatsapp,
  FaFileMedical,
  FaNotesMedical,
  FaHospital,
  FaSimplybuilt,
  FaBuilding,
  FaIdBadge,
  FaAddressCard,
} from 'react-icons/fa';

import { MdError, MdDateRange } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../../../components/Forms/Input';
import Button from '../../../components/Forms/Button';
import Loader from '../../../components/Loader';
import MaskedInput from '../../../components/Forms/MaskedInput';
import { ResponseMessage } from '../../../components/ResponseMessage';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Error } from './styles';
import SelectSimple from '../../../components/Forms/SelectSimple';
import Whatsapp from '../../../components/WhatsAppCompartilhar';

import api from '../../../services/api';
import { authTitle, recaptchaKey } from '../../../config';
import getCep from '../../../services/cep';
import CheckboxInput from '../../../components/Forms/CheckboxInput';
import { useLanguage } from '../../../hooks/Language';
import { countries } from '../../../pages/Products/modules/Login/countries';
import { useToast } from '../../../hooks/Toast';

interface IRecoverFormData {
  name: string;
  email: string;
  repeat_email: string;
  password: string;
  phone: string;
  captcha: string;
  birth_date: string;
 country: string;
 extra_2 : string;
 extra_3 : string;
 hash : string;
}

interface ICaptcha {
  getValue(): string;
}

const FormContainer = ({ context = {} }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const recaptchaRef = useRef(null);
  const {addToast} = useToast();
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };
  const [countryISO, setCountryISO] = useState('BR');
  const { translate} = useLanguage();

  const states = [
    { uf: 'AC', label: 'Acre (AC)', value: 1 },
    { uf: 'AL', label: 'Alagoas (AL)', value: 2 },
    { uf: 'AP', label: 'Amapá (AP)', value: 3 },
    { uf: 'AM', label: 'Amazonas (AM)', value: 4 },
    { uf: 'BA', label: 'Bahia (BA)', value: 5 },
    { uf: 'CE', label: 'Ceará (CE)', value: 6 },
    { uf: 'DF', label: 'Distrito Federal (DF)', value: 7 },
    { uf: 'ES', label: 'Espírito Santo (ES)', value: 8 },
    { uf: 'GO', label: 'Goiás (GO)', value: 9 },
    { uf: 'MA', label: 'Maranhão (MA)', value: 10 },
    { uf: 'MT', label: 'Mato Grosso (MT)', value: 11 },
    { uf: 'MS', label: 'Mato Grosso do Sul (MS)', value: 12 },
    { uf: 'MG', label: 'Minas Gerais (MG)', value: 13 },
    { uf: 'PA', label: 'Pará (PA)', value: 14 },
    { uf: 'PB', label: 'Paraíba (PB)', value: 15 },
    { uf: 'PR', label: 'Paraná (PR)', value: 16 },
    { uf: 'PE', label: 'Pernambuco (PE)', value: 17 },
    { uf: 'PI', label: 'Piauí (PI)', value: 18 },
    { uf: 'RJ', label: 'Rio de Janeiro (RJ)', value: 19 },
    { uf: 'RN', label: 'Rio Grande do Norte (RN)', value: 20 },
    { uf: 'RS', label: 'Rio Grande do Sul (RS)', value: 21 },
    { uf: 'RO', label: 'Rondônia (RO)', value: 22 },
    { uf: 'RR', label: 'Roraima (RR)', value: 23 },
    { uf: 'SC', label: 'Santa Catarina (SC)', value: 24 },
    { uf: 'SP', label: 'São Paulo (SP)', value: 25 },
    { uf: 'SE', label: 'Sergipe (SE)', value: 26 },
    { uf: 'TO', label: 'Tocantins (TO)', value: 27 },
    { uf: '', label: 'Não sou Brasileiro', value: 28 },
  ];

  const handleNewLogin = async (data: IRecoverFormData) => {
    setLoading(true);

    data.birth_date = data.birth_date
      ? data.birth_date.toString().replace(/[^0-9/]/g, '')
      : '';

    try {
      formRef.current?.setErrors({});

      const schema =   countryISO === 'BR' ? Yup.object().shape( {
       
        hash: Yup.string().required(`${translate('Código de cortesia')} ${translate('obrigatório')}`),

    
       
        name: Yup.string().required(`${translate('Nome')} ${translate('obrigatório')}`),
        email: Yup.string()
          .required(`${translate('Email')} ${translate('obrigatório')}`)
          .email(`${translate('Email')} ${translate('obrigatório')}`),

        phone: Yup.string().required(`${translate('Telefone')} ${translate('obrigatório')}`),
        password: Yup.string().required(`${translate('Senha')} ${translate('obrigatória')}`),

        document_number: Yup.string()
          .min(11, `${translate('CPF')} ${translate('obrigatório')}`)
          .required(`${translate('CPF')} ${translate('obrigatório')}`),

        birth_date: Yup.string()
          .min(10, translate('min 10 Preecha a Data de Nascimento'))
          .max(10, translate('max 10 Preecha a Data de Nascimento'))
          .required(`${translate('Data de Nascimento')} ${translate('obrigatório')}`),

          zipcode: Yup.string()
          .min(8, `${translate('CEP')} ${translate('obrigatório')}`)
          .max(8, `${translate('CEP')} ${translate('obrigatório')}`)
          .required(`${translate('CEP')} ${translate('obrigatório')}`),
        address: Yup.string().required(`${translate('Endereço')} ${translate('obrigatório')}`),
        address_number: Yup.string().required(`${translate('Endereço')} ${translate('obrigatório')}`),
        neighborhood: Yup.string().required(`${translate('Bairro')} ${translate('obrigatório')}`),
        city: Yup.string().required(`${translate('Cidade')} ${translate('obrigatório')}`),
        state: Yup.string()
          .max(2, translate('No máximo 2 caracteres'))
          .required(translate(`${translate('Estado')} ${translate('obrigatório')}`)),
   
      } ) : Yup.object().shape( {
   
        hash: Yup.string().required(`${translate('Código de cortesia')} ${translate('obrigatório')}`),
   
        
        name: Yup.string().required(`${translate('Nome')} ${translate('obrigatório')}`),
        email: Yup.string()
          .required(`${translate('Email')} ${translate('obrigatório')}`)
          .email(`${translate('Email')} ${translate('obrigatório')}`),

        phone: Yup.string().required(`${translate('Telefone')} ${translate('obrigatório')}`),
        password: Yup.string().required(`${translate('Senha')} ${translate('obrigatória')}`),

        document_number: Yup.string()

          .required(`${translate('CPF')} ${translate('obrigatório')}`),

        birth_date: Yup.string()
          .min(10, translate('min 10 Preecha a Data de Nascimento'))
          .max(10, translate('max 10 Preecha a Data de Nascimento'))
          .required(translate(`${translate('Data de Nascimento')} ${translate('obrigatória')}`)),

          zipcode: Yup.string()

          .required(`${translate('CEP')} ${translate('obrigatório')}`),
        address: Yup.string().required(`${translate('Endereço')} ${translate('obrigatório')}`),
        address_number: Yup.string().required(`${translate('Endereço')} ${translate('obrigatório')}`),
        neighborhood: Yup.string().required(`${translate('Bairro')} ${translate('obrigatório')}`),
        city: Yup.string().required(`${translate('Cidade')} ${translate('obrigatório')}`),
        state: Yup.string()

          .required(`${translate('Estado')} ${translate('obrigatório')}`),
   
      });

      let {email, hash, country, extra_2, extra_3} = data;


      const pais = countries.findIndex(c => c.value === country);
      if(pais){
        extra_3 = countries[pais].dialCode;
        extra_2 = countries[pais].label;
      }

      await schema.validate(data, { abortEarly: false });

      const captchaValue =
        getCaptchaValue(recaptchaRef?.current || { getValue: () => '' }) ||
        false;

      const response = await api.post(`/signup-cortesy`, {
        ...data,
        hash,
        captcha: captchaValue,
        extra_2,
        extra_3
      });

      setSuccess(true);
      setLoading(false);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (formRef && formRef.current && formRef.current.setErrors) {
          formRef.current.setErrors(errors);
        }
        setLoading(false);

        const errorsString = Object.keys(errors).reduce(
          (prev: Array<string>, key: string): Array<string> => {
            prev = [...prev, errors[key]];
            return prev;
          },
          [],
        );

        setErrorMessage(errorsString);

        return;
      }

      setErrorMessage([
    
          'Erro ao gerar seu cadastro',
      ]);
    }
    setLoading(false);
  };

  const getCepFromApi = async (value: string): Promise<void> => {
    const cepResponse = await getCep(value);

    const state = cepResponse.uf
      ? states.find(st => {
          return st.uf === cepResponse.uf;
        })
      : false;

    if (!cepResponse.error) {
      formRef?.current?.setFieldValue('address', cepResponse.logradouro);
      formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
      formRef?.current?.setFieldValue('city', cepResponse.localidade);
    
        formRef?.current?.setFieldValue('state', cepResponse.uf);
      
    }
  };

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside>
        {success ? (
          <ResponseMessage
            active
            type="success"
            title="Sucesso"
            description={
              <p>
                Cadastro realizado com sucesso!
                <br />
                <Link to="login">
                  <Button style={{ width: '100%' }} type="button">
                    Acessar
                  </Button>
                </Link>
                <br />
               
              </p>
            }
          />
        ) : (
         
      
           <Form ref={formRef} onSubmit={handleNewLogin} initialData={{country: 'BR'}}>
             
             <h1 className="defaultMarked" ><div/>{translate('Novo cadastro')}</h1>
             <Input icon={FaBuilding} name="hash" placeholder="Código de Cortesia" />
             <SelectSimple setCallback={(value) => setCountryISO(value) } options={countries} name="country" label={translate('Pais')}/>
             


             <Input name="name" placeholder={translate('Nome completo')} />
             <Input name="email" placeholder={translate('E-mail')} />
             <Input  name="repeat_email" placeholder={translate('Repita seu E-mail')} />

             <SelectSimple
                      options={[
                        { value: 'Mulher', label: translate('Mulher') },
                        { value: 'Homem', label: translate('Homem') },
                        { value: 'Não binário', label: translate('Não binário') },
                        { value: 'Prefiro não informar', label: translate('Prefiro não informar') },
                      ]}
                      name="gender"
                      formRef={formRef}
                      label={translate('Como você se identifica?')}
                    />

             { countryISO === 'BR' ? <MaskedInput
               mask="(99) 99999.9999"
               name="phone"
               placeholder={translate('Telefone')}
             /> : <Input name="phone"
             placeholder={translate('Telefone')}/>}

{ countryISO === 'BR' ? <Input style={{display:'none'}} name="document_type" value="cpf"
         placeholder={translate('Tipo de documento')}/> :  <SelectSimple name="document_type"
         label={translate('Tipo de Documento (Passaporte / Outro)')} options={[{label: translate('Passaporte'), value: 'passporte'}, {label: translate('Outro'), value: 'other'}]} />  }

{ countryISO === 'BR' ? <MaskedInput
               mask="999.999.999-99"
               name="document_number"
               placeholder={translate('CPF')}
         /> :  <Input name="document_number"
         placeholder={translate('Nº do documento')}/> }

         

             <MaskedInput
               mask="99/99/9999"
               name="birth_date"
               placeholder={translate('Data de Nascimento (DD/MM/YYYY)')}
             />



             <Input
               name="company"
               placeholder={translate('Empresa')}
             />


<Input
               name="position"
               placeholder={translate('Cargo')}
             />



<MaskedInput

       setCallback={getCepFromApi}
       mask="99999999"
       name="zipcode"
       placeholder={translate('CEP')}
     />
     <Input name="address" placeholder={translate('Endereço')} />
     <Input name="address_number" placeholder={translate('Número / Apartamento')} />
     <Input name="neighborhood" placeholder={translate('Bairro')} />
     <Input name="city" placeholder={translate('Cidade')} />
     { countryISO === 'BR' ?     <MaskedInput mask="aa" name="state" placeholder={translate('Estado')} /> : 

<Input name="state" placeholder={translate('Estado')} />}


             <Input
               icon={FiLock}
               name="password"
               type="password"
               placeholder={translate('Cadastre sua senha de acesso')}
             />


<CheckboxInput
              style={{ display: 'flex'  }}
              name="term"
              unique={true}
              preText={(
                <>
                  {' '}
                  O {authTitle} deseja enviar comunicações, via e-mail e SMS, tais como conteúdos especiais, newsletter, promoções e divulgações do projeto. Assinale abaixo se você aceita recebê-las:.
{' '}
                 
                </>
              )}
              options={[
                {
                  id: `Sim, aceito receber comunicações por e-mail e SMS`,
                  label: 'Sim, aceito receber comunicações por e-mail e SMS',
                  value: `Sim, aceito receber comunicações por e-mail e SMS`,
                },
                {
                  id: `Aceito apenas receber comunicações por e-mail`,
                  label: 'Aceito apenas receber comunicações por e-mail',
                  value: `Aceito apenas receber comunicações por e-mail`,
                },
                {
                  id: `Aceito apenas receber comunicações por SMS`,
                  label: 'Aceito apenas receber comunicações por SMS',
                  value: `Aceito apenas receber comunicações por SMS`,
                },
                {
                  id: `Não aceito receber comunicações`,
                  label: 'Não aceito receber comunicações',
                  value: `Não aceito receber comunicações`,
                },
              ]}
            />

<p
                style={{
                  padding: '10px',
                  background: 'none',
                  margin: '5px auto',
                  color: '#fff',
                  fontSize: '12px',
                  textAlign: 'left',
                }}
              >
                {translate('Ao me cadastrar, afirmo que li e aceito a')}
{' '}
                <strong>
                  <Link
                    style={{ display: 'inline', color: '#fff' }}
                    to="/termos"
                    target="_BLANK"
                  >
                    {translate('POLÍTICA DE PRIVACIDADE')}
{' '}
                  </Link>
{' '}
                </strong>
                {translate('do evento.')}
              </p>

              <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />
            {errorMessage && (
              <Error>
                {errorMessage.map((item, index) => (
                  <div key={`error${index}`}>
                    <MdError />
                    {item}
                  </div>
                ))}
              </Error>
            )}
            <Button style={{ width: '100%' }} type="submit">
              Cadastrar
            </Button>
          </Form>
        )}
      </aside>
    </>
  );
};

export default FormContainer;
